define('models/PaymentBrandCollection',['underscore','ObjectCollection','LocalStorage','models/PaymentBrandModel'],function (_,ObjectCollection,LocalStorage,PaymentBrandModel) {
    //
    // Collection PaymentBrand
    //
    var PaymentBrandCollectionPrototype = {
        
        name:'PaymentBrandCollection',
        route:'apiPaymentBrandCollection',
        model:PaymentBrandModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
        byIds:function(idBrands, id_payment_mode){
            var filtred = this.filter(function(paymentBrand){
                var id = paymentBrand.get('id_payment_mode');
                return (idBrands||[]).indexOf(paymentBrand.id) >= 0 && (id_payment_mode == id);
            });
            return new PaymentBrandCollection(filtred);
        },
    };

    var PaymentBrandCollection = ObjectCollection.extend(LocalStorage).extend(PaymentBrandCollectionPrototype);

    return PaymentBrandCollection;
});
